<template>
    <div>
        <div  id="panel-description" class="panel">
            <div class="panel-hdr bg-primary-700 bg-success-gradient">
                <h2 >Тендер № {{ this.tender?.number }} ({{ this.tender?.status }})</h2>
                
                <div class="panel-toolbar">
                    <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse">
                    </button>
                    
                    <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                    </button>
                </div>
            </div>
            
            <div class="panel-container collapse show">
                <div class="panel-content">
                    
                    <BOverlay :show="is_load">
                        
                        <tender_info v-if="!is_load" :tender="tender"></tender_info>
                        
                        <BTabs  v-model:index="tabIndex" v-model="tabId" content-class="mt-3">
                            
                            <BTab v-for="(tab,index) in tabs"
                                  :disabled="tab.disabled"
                                  :id="index"
                                  :title="tab.title"
                                  :active="tab.is_active"
                                  :key="index"
                            >
                                
                                <template #title>
                                    {{tabTitle(tab)}}
                                    <BSpinner type="grow" small v-if="tab.is_load" />
                                </template>
                                
                                <component v-bind:is="tab.index" :tender="tender"></component>
                            </BTab>
                        </BTabs>
                        
                        <!-- Control buttons-->
                        <div class="text-center">
                            <BButtonGroup class="mt-2">
                                <BButton variant="outline-primary" @click="tabIndex--">Назад</BButton>
                                <b-button variant="outline-primary" @click="tabIndex++">Далі</b-button>
                            </BButtonGroup>
                        </div>
                        
                        <div class="pt-3" v-if="rights == 'manager '">
                            <BButton class="waves-effect waves-themed" variant="outline-primary" @click="go_protocol">
                                Створити протокол
                            </BButton>
                        </div>
                    
                    </BOverlay>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {
    BTabs,
    BTab,
    BOverlay,
    BSpinner,
    BButton,
    BButtonGroup
} from 'bootstrap-vue-next';
import Tender_info from "./tabs/tender_info.vue";

import tender_nomenclature from "./tabs/tender_nomenclature.vue";
import tender_description from "./tabs/tender_description.vue";
import tender_files from "./tabs/tender_files.vue";
import tender_subscribes from "./tabs/tender_subscribes.vue";
import tender_history from "./tabs/tender_history.vue";
import tender_request from "./tabs/tender_request.vue";

export default {
    name: "tender_inside",
    props: {
        tender_id: {
            type: [Number, String],
            required: true,
        },
        
        rights : {
            type: [ String],
            default : "",
        }
    },
    
    components: {
        Tender_info,
        BTab,
        BTabs,
        BOverlay,
        BSpinner,
        BButton,
        BButtonGroup,
        tender_nomenclature,
        tender_description,
        tender_files,
        tender_subscribes,
        tender_history,
        tender_request
    },
    
    data() {
        return {
            is_load: false,
            tabIndex: -1,
            tabId: "tender_general",
            tender: {},
            tabs: []
        }
    },
    
    created() {
        this.loadTender();
    },
    
    methods: {
        save() {
        
        },
        
        tabTitle(tab) {
            return tab.title;
        },
        
        
        go_protocol() {
            window.location.href="/protokoly/new/" + this.tender_id;
        },
        
        async loadTender() {
            this.is_load = true;
            
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender_id)).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.tender = data.data;
                    this.pushTabs();
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        pushTabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    disabled: item.disabled,
                    is_active: item.is_active,
                    is_load: false,
                    index: item.index,
                });
            });
        }
    },
    
    computed: {
        
        is_new() {
            return parseInt(this.tender_id) === 0;
        },
        
        is_published() {
            let cur_state = this.tender?.status;
            return cur_state === 'published';
        },
        
        default_tabs() {
            let def = [
                {
                    "title": "Заявки",
                    "index": "tender_request",
                    is_active: true,
                    disabled: false,
                },
                
                {
                    "title": "Номенклатура ",
                    "index": "tender_nomenclature",
                    is_active: false,
                    disabled: false,
                },
                
                {
                    "title": "Файли",
                    "index": "tender_files",
                    is_active: false,
                    disabled: false,
                },
                {
                    "title": "Опис",
                    "index": "tender_description",
                    is_active: false,
                    disabled: false,
                },
                {
                    "title": "Запрошення",
                    "index" : "tender_subscribes",
                    is_active: false,
                    disabled: false,
                },
                {
                    "title": "Повідомлення",
                    "index" : "tender_history",
                    is_active: false,
                    disabled: false,
                },
            ]
            
            return def;
        }
    }
}
</script>



<style scoped>

</style>